import { render } from "./FormularioFacturacion.vue?vue&type=template&id=253e11ea&scoped=true"
import script from "./FormularioFacturacion.vue?vue&type=script&lang=js"
export * from "./FormularioFacturacion.vue?vue&type=script&lang=js"

import "./FormularioFacturacion.vue?vue&type=style&index=0&id=253e11ea&scoped=true&lang=css"

import exportComponent from "D:\\GIT\\Interfaz_Colecturia\\colecturia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253e11ea"]])

export default __exports__